export enum WarehouseType {
  MAIN = 'MAIN',
  VAN = 'VAN',
}
